import { Injectable } from '@angular/core';
import {LanguageService} from '../language/language.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DATETIME_FORMAT_REQUEST, FILTER_DEFAULT_END_TIME, FILTER_DEFAULT_START_TIME } from 'src/app/utils/constant';
import { FormControl } from '@angular/forms';
import { IUnsavedChangesComponent } from 'src/app/guards/UnsavedChangesGuard';

export type TCanDeactivateComponents = {
  id: string,
  component: IUnsavedChangesComponent
}

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  private canDeactiveComponents:Array<TCanDeactivateComponents> = [];

  constructor(
    private languageService : LanguageService
  ) { }

  // public initLocale(){
  //   let langs = _.map(LANGUAGES, 'value');
  //   this.translate.addLangs(langs);
    
  //   this.translate.setDefaultLang(DEFAULT_LANGUAGE);

  //   let lang;
    
  //   if(localStorage.getItem(KEY_STORAGE_LANGUAGE)){
  //     lang = localStorage.getItem(KEY_STORAGE_LANGUAGE);
  //   } else {
  //     if(_.indexOf(langs, this.translate.getBrowserLang()) >= 0){
  //       lang = this.translate.getBrowserLang();
  //     } else {
  //       lang = DEFAULT_LANGUAGE;
  //     }
  //     localStorage.setItem(KEY_STORAGE_LANGUAGE, DEFAULT_LANGUAGE);
  //   }

  //   this.translate.use(lang);
  // }

  // public getLocale(){
  //   return localStorage.getItem(KEY_STORAGE_LANGUAGE);
  // }

  // public updateLocale(locale){
  //   this.translate.use(locale);
  //   localStorage.setItem(KEY_STORAGE_LANGUAGE, locale);
  // }

  public randomString(n: number = 6){
   return Math.random().toString(36).substring(n);
  }

  public convertToLocalDatetime(objArr) {
    objArr.forEach(obj => {
      Object.keys(obj).forEach(function(key) {
        if(_.isString(obj[key]) && _.isNaN(_.toNumber(obj[key])) && moment(obj[key]).isValid()) {
          obj[key] = moment.utc(obj[key]).local();
        }
      });
    });
    return objArr;
  }

  public convertToBase64(data): string {
    let base64String: string = null;

    if (data != null && data != undefined && data != "") {
      base64String = btoa(data);
    }

    return base64String;
  }

  public unsubscribeSubscription(subscription: Subscription) {
    if (subscription && !subscription.closed) {
      return subscription.unsubscribe();
    }
  }

  public formatDateTimeLocal(date:any, format = 'MM/DD/YYYY') {
    return moment.utc(date).local().format(format);
  }

  public getDateTimeLocal({date = null, time = null, formatDateTime = "MM/DD/YYYY hh:mm A", dateOnly = false, formatDate = "MM/DD/YYYY", timeOnly = false, formatTime = "hh:mm A"}) {
    if (!date) {
      throw new Error("Date cant be null");
    }
    if (dateOnly && timeOnly) {
      throw new Error("Please enable only 1 mode; dateOnly or TimeOnly");
    }

    let datetime
    if (time) {
      datetime = moment(date).format('YYYY-MM-DD').toString() + " " + time;
    } else {
      datetime = moment(date).format('YYYY-MM-DD HH:mm:ss').toString();
    }
    
    let localDateTime = moment.utc(datetime).local();

    if (dateOnly) {
      return localDateTime.format(formatDate)
    } else if (timeOnly) {
      return localDateTime.format(formatTime)
    } else {
      return localDateTime.format(formatDateTime)
    }
  }

  public getDateTimeUTC({date = null, time = null, formatDateTime = "MM/DD/YYYY hh:mm A", dateOnly = false, formatDate = "MM/DD/YYYY", timeOnly = false, formatTime = "hh:mm A"}) {
    
    if (!date) {
      throw new Error("Date cant be null");
    }
    if (dateOnly && timeOnly) {
      throw new Error("Please enable only 1 mode; dateOnly or TimeOnly");
    }

    let datetime
    if (time) {
      datetime = moment(date).format('YYYY-MM-DD').toString() + " " + time;
    } else {
      datetime = moment(date).format('YYYY-MM-DD HH:mm:ss').toString();
    }
    
    let utcDateTime = moment(datetime).utc();

    if (dateOnly) {
      return utcDateTime.format(formatDate)
    } else if (timeOnly) {
      return utcDateTime.format(formatTime)
    } else {
      return utcDateTime.format(formatDateTime)
    }
  }

  /**
   * Function to set from date and to date for filter request
   * if monthCoverage, function will set fromDate and toDate to cover their whole month. sample: Jan 1 - Feb 28
   * if not monthCoverage, function will return the exact date as passed.
   * Automatically adds covering time. See FILTER_DEFAULT_START_TIME & FILTER_DEFAULT_END_TIME.
   * And formats to the accepted format of the Server.
   * @param param0 
   * @returns object
   */
  public getFilterComponentDateTimeRequestUTC({ fromDate, toDate = null, monthCoverage = true }) {
    let from_date = this.getDateTimeUTC({
      date: monthCoverage ? moment(fromDate).startOf('month') : moment(fromDate),
      time: FILTER_DEFAULT_START_TIME,
      formatDateTime: DATETIME_FORMAT_REQUEST
    })

    let to_date = null;

    if (!toDate) {
      to_date = this.getDateTimeUTC({
        date: monthCoverage ? moment(fromDate).endOf('month') : moment(fromDate),
        time: FILTER_DEFAULT_END_TIME,
        formatDateTime: DATETIME_FORMAT_REQUEST
      })
    } else {
      to_date = this.getDateTimeUTC({
        date: monthCoverage ? moment(toDate).endOf('month') : moment(toDate),
        time: FILTER_DEFAULT_END_TIME,
        formatDateTime: DATETIME_FORMAT_REQUEST
      })
    }

    return { from_date, to_date }

  }

  public formatAddress(address, city, state, country, zip, barangay=null) {
    let formattedAddress = (address ? address + ', ' : '') +
    (barangay ? barangay + ', ' : '') +
    (city ? city + ', ' : '') +
    (state ? state + ', ' : '') +
    (country ? country + ' ': '') +
    (zip ? zip : '') 
    return formattedAddress
  }

  public formatName(firstname, middlename, lastname, suffix) {
    let formattedName = firstname + ' ' +
    (middlename ? middlename + ' ' : '') +
    lastname + ' ' +
    (suffix ? suffix  : '')
    return formattedName
  }

  /**
   * Function that is used to determine if a string exceeds the character limit.
   * Used on conditional showing of matToolTip on maintenance details view
   * @param text  string to analyze
   * @param charLimit character limit, hardcoded to 100
   * @returns boolean
   */
  isWide(text:String, charLimit=100) {
    return text.length >= charLimit
  }

  log(message:string, object:any = null) {
    if (!environment.production) {
      console.log('%c' + message, 'background: #bada55; color: #222')
      console.log(object ? object : null)
    }
  }

  registerCanDeactivateComponent(id: string, component: IUnsavedChangesComponent) {
    const tComponent = {
      id: id,
      component: component
    }

    const exist = this.canDeactiveComponents.some(item => item.id === tComponent.id);
    
    if (exist) {
      if(!environment.production){console.log('%c' + 'Registering an existing component to helper\'s canDeactivateComponents. This is normal if you are reopening a component.', 'background: #bada55; color: #222');};
      return;
    }

    this.canDeactiveComponents.push(tComponent);
  }

  getRegisteredCanDeactivateComponents():IUnsavedChangesComponent[] {
    const components = this.canDeactiveComponents.map(item => {
      return item.component
    })
    return components ? components : null;
  }

  clearRegisteredCanDeactivateComponents() {
    this.canDeactiveComponents = [];
  }

  /**
   * Function to check if at least 1 of the registered component has unsaved changes.
   * This is used on pages.component.ts logout.
   * How its used: Imagine we are editing a form. We needed this because, on logout we navigate to /login. 
   * Since we are navigating the CanDeactiveGuard will be called and a dialog will pop up.
   * Since we cant subscribe to the dialog from UnsavedChangesGuard, we will need to find a way to detect unsaved changes.
   * Hence this logic.
   * Since we can't subscribe, without this, the logout function on pages.component.ts will continue to logout the application.
   * Even if the user cancelled the dialog to navigate to login.
   * @returns boolean
   */
  hasUnsaved() {
    const components = this.getRegisteredCanDeactivateComponents();
    
    return components.some(component => {
      // console.log(component, component.hasUnsavedChanges());
      return component.hasUnsavedChanges();
    });
  }

  /**
   * Get actual status from actual_status object from host.
   * Make sure element has actual_status object
   */
  getActualBookingStatus(data){
    const isOnhold = data?.actual_status?.is_onhold === 1;
    const onHoldIdentifier = this.languageService.getTranslation("ONHOLD_INDENTIFIER",null);
    return `${data?.actual_status?.description} ${isOnhold ? onHoldIdentifier : ""}` 
  }

}
